export const info = [
    {
      id: 1,
      title: "How accurate is our predictor?",
      details:
        "Our Disease Predictor has an accuracy above 90% for most conditions, however, always consult a healthcare professional for a proper diagnosis."
    },
    {
      id: 2,
      title: "Is the predictor constantly updated?",
      details:
        "Yes, our algorithm is updated regularly with the latest medical data to provide the most accurate predictions."
    },
    {
      id: 3,
      title: "Can I use it for emergencies?",
      details:
        "No, our Disease Predictor is not meant for emergency use. In life-threatening situations, please contact emergency services directly."
    }
  ];
